module.exports = __webpack_public_path__ + "img/transform_img.523f7f44.svg";